import React from "react";
import { node, string } from "prop-types";
import classNames from "classnames";

const GridTableBody = ({ children, className, ...props }) => (
    <div className={classNames("grid-table-body", className)} {...props}>
        {children}
    </div>
);

GridTableBody.propTypes = {
    children: node.isRequired,
    className: string,
};

GridTableBody.defaultProps = {
    className: "",
};

export default GridTableBody;
